import $ from 'jquery';

import replaceQueryString from './replaceQueryString';

const setupWorknoButton = (userInfo, prgList) => {
	$('#password-login-button').on('click', () => {
		if (!$('#password-login-button').hasClass('-disable') &&
			!$('#password-login-button').hasClass('-loading')) {
			$('#password-login-button').addClass('-loading');

			/**
			 * redirect to surveycake
			 */
			window.location.href = replaceQueryString(
				prgList[$('#prglist-selectbox').val()].PGMURL,
				userInfo[0],
			);
		}
	});
};

export default setupWorknoButton;



// WEBPACK FOOTER //
// ./src/js/index/setupWorknoButton.js